import * as React from 'react';
import { TweenMax } from 'gsap';
import css from './index.module.scss';
import { EFXBoostH5 } from '@/components/UI/svg/river2';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowRightBlueSmall from '@/components/UI/svg/Icons/EFArrowRightBlueSmall';
import EFVideo from '@/components/UI/EFVideo';
import EcoImg from 'eco-design/base/eco-img';

export default function I() {
    const { useLang, useRouter, Link, useEffect } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const isShowLink = ['us', 'ca', 'au', 'uk', 'za', 'sa', 'eu', 'mx'].includes(locale);
    const videoMap: any = {
        us: ['/video/river2/details/h5/9_us.webm', '/video/river2/details/h5/9_us.mp4'],
        cn: ['/video/river2/details/h5/9_cn.webm', '/video/river2/details/h5/9_cn.mp4'],
        eu: ['/video/river2/details/h5/9_eu.webm', '/video/river2/details/h5/9_eu.mp4'],
        ph: ['/video/river2/details/h5/9_eu.webm', '/video/river2/details/h5/9_eu.mp4'],
        de: ['/video/river2/details/h5/9_eu.webm', '/video/river2/details/h5/9_eu.mp4'],
        fr: ['/video/river2/details/h5/9_eu.webm', '/video/river2/details/h5/9_eu.mp4'],
        it: ['/video/river2/details/h5/9_eu.webm', '/video/river2/details/h5/9_eu.mp4'],
        es: ['/video/river2/details/h5/9_eu.webm', '/video/river2/details/h5/9_eu.mp4'],
        cis: ['/video/river2/details/h5/9_eu.webm', '/video/river2/details/h5/9_eu.mp4'],
        jp: ['/video/river2/details/h5/9_jp.webm', '/video/river2/details/h5/9_jp.mp4'],
        uk: ['/video/river2/details/h5/9_uk.webm', '/video/river2/details/h5/9_uk.mp4'],
        za: ['/video/river2/details/h5/9_za.webm', '/video/river2/details/h5/9_za.mp4'],
        au: ['/video/river2/details/h5/9_au.webm', '/video/river2/details/h5/9_au.mp4'],
        kr: ['/video/river2/details/h5/9_eu.webm', '/video/river2/details/h5/9_eu.mp4'],
    };

    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        new ScrollMagic.Scene({
            triggerElement: '.river2_details_I .xboostLogo',
            triggerHook: 1,
            offset: 100,
            duration: layoutH / 2,
        })
            .setTween(TweenMax.to('.river2_details_I .xboostLogo', 0.5, { width: '0.91rem', height: '0.25rem' }))
            .addTo(AniContainer);

        new ScrollMagic.Scene({
            triggerElement: '.river2_details_I .xboostLogo',
            triggerHook: 1,
            offset: 100,
            duration: layoutH / 2,
        })
            .setTween(TweenMax.to('.river2_details_I .logoBox', 0.5, { paddingBottom: 0 }))
            .addTo(AniContainer);
    }, []);

    return (
        <div className={`river2_details_I ${css.I_9}`}>
            <div className="innerBox">
                <div className="logoBox">
                    <div className="xboostLogo">
                        <EFXBoostH5 />
                    </div>
                </div>
                <div className="textBox">
                    <p className="title">{t('river2.details.sec9_title_h5')}</p>
                    <p className="subTitle">{t('river2.details.sec9_xboost_up')}</p>
                    <div className="desc">
                        {t.rich('river2.details.sec9_desc', {
                            p1: (child: React.ReactNode) => <span className="title-p1">{child}</span>,
                            p2: (child: React.ReactNode) => <span className="title-p2">{child}</span>,
                        })}

                        {isShowLink && (
                            <Link href="/x-boost" className="stream-link" newWin>
                                <div className="link font-family-regular">
                                    <span>{t('x_boost_link')}</span>
                                    <EFArrowRightBlueSmall width="0.14rem" height="0.14rem" />
                                </div>
                            </Link>
                        )}
                    </div>
                </div>
                <div className="imgBox">
                    {locale === 'ph' ? (
                        <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1751272164437/a-h5.jpg" className="fullImgs" />
                    ) : (
                        <EFVideo sources={videoMap[locale] || videoMap.us} width="100%" height="100%" className="fullImgs" />
                    )}
                </div>
            </div>
        </div>
    );
}
